import i18n from 'i18n/index';
import { round, isNumber } from 'lodash';
import { decimalPrecision } from 'config/marketConfig';


export const truncateDecimals = (number, decimals) =>
  Math.trunc(number * Math.pow(10, decimals)) / Math.pow(10, decimals);

export const roundFix = (number, decimals = decimalPrecision) => Math.round(number.toFixed(decimals));

export const roundToNearest = (number, precision, withTruncation = false) => {
  if (withTruncation) return number && number < precision ? truncateDecimals(number, 0) : Math.round(number / precision) * precision;
  return Math.round(number / precision) * precision;
}

export const addThousandSeparator = (number, { fixed = 0, thousandSeparator = ',', decimalSeparator = '.' } = {}) => {
  if (!isNumber(number)) return '0';

  const roundedNumber = round(number, fixed).toString();
  const [integerPart, decimalPart = ''] = roundedNumber.split('.');

  const integerWithSeparator = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
  const formattedNumber = decimalPart ? `${decimalSeparator}${decimalPart}` : '';

  return `${integerWithSeparator}${formattedNumber}`;
};

export const roundThousandAndAddThousandSeparator = (number, formatOptions = {}) => {
  const roundedNumber = roundToNearest(number, formatOptions.roundNearest, formatOptions.withTruncation);
  return addThousandSeparator(roundedNumber, formatOptions);
};

export const addPlusMinus5PercentageRangeToNumber = (number, formatOptions = {}) =>
  `${roundThousandAndAddThousandSeparator(number * 0.95, formatOptions)} ${i18n.t(
    'summary.to',
  )} ${roundThousandAndAddThousandSeparator(number * 1.05, formatOptions)}`;
